var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", { staticClass: "link-preview" }, [
    _c("section", { staticClass: "link-preview__body" }, [
      _vm.resource.image
        ? _c("img", {
            staticClass: "link-preview__image",
            attrs: {
              src: _vm.resource.image,
              alt: `${_vm.resource.title} Preview image`,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "link-preview__content" },
        [
          _c(
            "a",
            {
              staticClass: "link-preview__title",
              attrs: { href: _vm.resource.url, target: "_blank" },
            },
            [_vm._v(_vm._s(_vm.resource.title))]
          ),
          _vm._v(" "),
          _c("SvgIcon", {
            staticClass: "link-preview__icon",
            attrs: { icon: "link" },
          }),
          _vm._v(" "),
          _vm.resource.description
            ? _c("p", {
                staticClass: "link-preview__description",
                domProps: { textContent: _vm._s(_vm.resource.description) },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.resource.url
      ? _c("footer", { staticClass: "link-preview__footer" }, [
          _c("a", { attrs: { target: "_blank", href: _vm.resource.url } }, [
            _vm._v(_vm._s(_vm.resource.url)),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }